module.exports = __webpack_public_path__ + "static/media/print.696f5c2e.jpg";